import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useCommon } from '../../store/CommonContext';
import { usePayment } from '../../store/PaymentContext';

import Loader from '../../components/loader/Loader';
import { FONT_FAMILY, MODAL_BORDER_RADIUS } from '../../components/constants/style-constants';
import Logo from '../../components/logo/Logo';
import Title from '../../components/text/Title';
import Content from '../../components/blocks/Content';
import HorizontalLine from '../../components/decorations/lines/HorizontalLine';
import List from '../../components/list/List';
import ListItem from '../../components/list/ListItem';
import Button from '../../components/buttons/Button';
import CancelLink from '../../components/text/CancelLink';
import Terms from '../../components/text/Terms';
import CloseButton from '../../components/buttons/CloseButton';
import { eligibilityApprove } from '../../store/PaymentContext';

import './Concent.css';

interface Props {}

const Consent: React.FC<Props> = () => {
  const {
    state: { configurationLoading, orderDataLoading, configuration, orderData },
    dispatch: commonDispatch,
  } = useCommon();
  const {
    dispatch,
    state: { paymentLoading },
  } = usePayment();

  const navigate = useNavigate();
  const amount =
    orderData?.amount && !isNaN(Number((orderData?.amount / 100).toFixed(2)))
      ? Number((orderData?.amount / 100).toFixed(2))
      : '';

  const handleClick = async (): Promise<void> => {
    // redirectToSuccess();
    eligibilityApprove(dispatch, navigate, commonDispatch);
  };

  if (configurationLoading || orderDataLoading || paymentLoading) {
    return <Loader />;
  }

  return (
    <div
      className="consent dialog"
      style={{
        ...(configuration?.fontFamily && { fontFamily: configuration.fontFamily as string }),
        ...(configuration?.modalCornersRadius && { borderRadius: configuration.modalCornersRadius as string }),
      }}
    >
      <CloseButton dataid={null} />
      <Logo imageUrl="https://portal.flex-charge.com/media/flex-logo-small.png" />
      <Content>
        <>
          <Title
            text={`Your payment of ${
              orderData?.currencySymbol || ''
            }${amount} has failed but no worries, you can complete your purchase anyway!`}
          />
          {/*<HorizontalLine />*/}
          <List>
            <>
              <ListItem>
                <>Just click OK below to complete your purchase anyway</>
              </ListItem>
              <ListItem>
                <>You will be charged {amount} when the issue with your payment gets resolved</>
              </ListItem>
              <ListItem>
                <>
                  You will be charged {amount} only. <br />
                  <span className="ui-widget-item-bold">No interest, no fees. Ever.</span>
                </>
              </ListItem>
            </>
          </List>
        </>
      </Content>

      {/*<HorizontalLine />*/}
      <Terms />
      <Button disabled={false} text="OK" onClick={handleClick} />
      <CancelLink />
      {/*<Copyright />*/}
    </div>
  );
};

export default Consent;
